import gql from 'graphql-tag';

export const GetNotesQuery = gql`
	query NotesByCreator($limit: Int!) {
		notesByCreator(input: { isAscending: true, first: $limit }) {
			nodes {
				ari
				title
				body
				bodyExcerpt
				createdAt
				updatedAt
				isPinned
				backgroundColor
			}
		}
	}
`;
